import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { APP_URL } from '../config';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 635.000000 626.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,626.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M3065 6023 c-33 -1 -94 -7 -135 -13 -41 -5 -100 -13 -130 -16 -30 -3
-91 -14 -135 -24 -44 -10 -104 -22 -132 -26 -29 -3 -53 -10 -53 -15 0 -5 -6
-9 -12 -9 -28 0 -236 -68 -328 -107 -163 -70 -219 -97 -214 -105 3 -4 -1 -5
-9 -2 -8 3 -20 -2 -27 -11 -7 -8 -19 -15 -26 -15 -15 0 -97 -50 -102 -62 -2
-4 -10 -4 -18 -1 -8 3 -14 0 -14 -6 0 -6 -5 -11 -10 -11 -14 0 -93 -58 -103
-76 -5 -8 -12 -12 -17 -9 -8 5 -60 -29 -123 -81 -9 -8 -20 -14 -23 -14 -3 0
-50 -39 -106 -87 -55 -49 -110 -95 -122 -103 -11 -8 -23 -18 -24 -23 -7 -14
-63 -67 -72 -67 -5 0 -11 -8 -14 -17 -3 -10 -22 -34 -41 -53 -54 -55 -225
-267 -225 -280 0 -3 -10 -16 -23 -30 -67 -73 -277 -474 -319 -607 -7 -24 -16
-43 -20 -43 -5 0 -8 -6 -8 -12 0 -7 -16 -62 -36 -123 -20 -60 -42 -139 -49
-175 -7 -36 -20 -99 -28 -140 -41 -193 -51 -302 -51 -555 0 -155 4 -269 12
-300 6 -27 16 -81 22 -120 6 -38 13 -81 15 -95 2 -14 4 -32 5 -40 1 -8 5 -4 9
9 4 14 7 -9 7 -53 1 -52 5 -80 14 -86 7 -4 9 -13 5 -19 -4 -7 -1 -19 6 -27 6
-8 9 -17 6 -21 -4 -3 -3 -11 2 -17 4 -6 18 -45 30 -86 28 -93 40 -126 57 -167
8 -18 21 -50 30 -70 38 -94 181 -381 195 -393 11 -10 149 -224 149 -232 0 -4
4 -8 9 -8 5 0 27 -24 50 -54 181 -240 539 -555 786 -691 39 -22 76 -45 83 -52
7 -7 23 -13 34 -13 12 0 19 -3 15 -6 -10 -10 279 -148 293 -139 5 3 10 1 12
-3 3 -10 136 -62 156 -62 7 0 20 -4 30 -10 9 -5 85 -27 167 -49 245 -66 611
-102 877 -86 71 4 126 10 124 14 -2 3 24 6 57 6 72 1 218 20 297 40 152 38
257 67 275 75 11 5 51 21 89 35 38 14 76 31 85 38 12 10 13 9 6 -2 -5 -9 5 -7
31 7 21 11 55 27 74 35 107 46 272 130 339 175 14 9 34 22 43 27 46 28 169
115 213 150 28 22 66 52 85 67 69 52 172 157 166 167 -4 6 -1 9 6 6 17 -7 165
146 241 248 31 42 62 77 67 77 6 0 10 6 10 13 0 6 18 34 39 61 33 42 38 53 29
70 -8 17 -8 19 2 9 10 -10 19 -2 43 35 16 26 32 49 36 52 3 3 22 37 41 75 19
39 37 72 40 75 12 10 99 198 126 270 15 41 31 80 35 85 5 6 12 29 18 50 25 97
54 191 62 200 5 5 9 20 9 35 0 14 9 57 20 95 11 39 20 83 20 98 0 16 4 36 9
45 5 10 12 45 15 77 3 33 10 112 16 175 16 154 5 538 -16 559 -2 2 -4 -8 -4
-22 0 -15 -5 -27 -11 -27 -11 0 -3 37 13 57 6 7 3 40 -7 90 -8 43 -25 128 -37
188 -11 61 -25 112 -29 113 -5 2 -9 11 -9 19 0 20 -60 225 -70 238 -4 6 -15
34 -25 63 -11 28 -23 52 -27 52 -4 0 -8 8 -8 17 0 27 -24 86 -42 107 -10 11
-18 23 -18 28 0 28 -170 327 -208 367 -7 8 -21 26 -30 40 -18 28 -105 144
-133 176 -43 50 -141 161 -151 170 -5 6 -22 23 -36 39 -15 15 -33 33 -41 40
-7 6 -39 35 -72 64 -32 30 -63 51 -68 47 -6 -3 -8 0 -5 8 3 9 -8 23 -33 37
-21 13 -42 28 -48 34 -12 13 -75 61 -125 95 -19 13 -37 26 -40 30 -3 3 -18 14
-35 23 -16 9 -46 26 -65 38 -93 56 -144 84 -255 138 -66 33 -140 67 -165 77
-25 10 -65 26 -89 37 -24 11 -59 20 -77 21 -17 1 -30 5 -28 8 2 3 -31 17 -74
29 -42 13 -84 26 -92 31 -18 9 -219 49 -305 60 -33 5 -73 11 -90 14 -118 19
-358 27 -540 18z m-128 -39 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13
-5z m626 -1 c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17 0 24 -2 18 -5z m-755 -12
c11 -6 10 -10 -4 -15 -9 -3 -19 -4 -22 -1 -3 3 1 5 9 5 11 0 11 2 -1 10 -8 5
-10 10 -5 10 6 0 16 -4 23 -9z m883 2 c-10 -4 -10 -7 -1 -13 8 -5 7 -9 -5 -13
-9 -4 -13 -3 -10 3 3 6 -2 10 -12 11 -16 0 -16 1 2 9 11 5 25 9 30 9 6 -1 4
-3 -4 -6z m-951 -13 c-25 -8 -25 -8 5 -10 17 -1 24 -4 17 -7 -7 -3 -25 -2 -39
2 -21 5 -24 8 -12 16 7 5 23 8 34 8 16 -1 16 -2 -5 -9z m1030 0 c18 -12 2 -12
-25 0 -13 6 -15 9 -5 9 8 0 22 -4 30 -9z m-874 -9 c-3 -5 -15 -7 -26 -4 -28 7
-25 13 6 13 14 0 23 -4 20 -9z m-238 -8 c-10 -2 -26 -2 -35 0 -10 3 -2 5 17 5
19 0 27 -2 18 -5z m1205 0 c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17 0 24 -2 18
-5z m-1628 -123 c-3 -5 -13 -10 -21 -10 -8 0 -12 5 -9 10 3 6 13 10 21 10 8 0
12 -4 9 -10z m2035 0 c13 -8 13 -10 -2 -10 -9 0 -20 5 -23 10 -8 13 5 13 25 0z
m80 -30 c8 -5 11 -10 5 -10 -5 0 -17 5 -25 10 -8 5 -10 10 -5 10 6 0 17 -5 25
-10z m-2345 -70 c-3 -5 -16 -10 -28 -10 -18 0 -19 2 -7 10 20 13 43 13 35 0z
m2490 0 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z
m-2645 -83 c0 -7 -12 -14 -27 -15 l-28 -2 25 14 c14 8 26 14 28 15 1 1 2 -5 2
-12z m2816 -2 c17 -16 14 -18 -10 -9 -9 3 -16 10 -16 15 0 13 9 11 26 -6z
m-3236 -295 c0 -5 -7 -10 -15 -10 -8 0 -15 5 -15 10 0 6 7 10 15 10 8 0 15 -4
15 -10z m-70 -40 c0 -5 -2 -10 -4 -10 -3 0 -8 5 -11 10 -3 6 -1 10 4 10 6 0
11 -4 11 -10z m3815 -30 c10 -11 16 -20 13 -20 -3 0 -13 9 -23 20 -10 11 -16
20 -13 20 3 0 13 -9 23 -20z m-30 -20 c10 -11 16 -20 13 -20 -3 0 -13 9 -23
20 -10 11 -16 20 -13 20 3 0 13 -9 23 -20z m-3950 -99 c-3 -6 -11 -11 -16 -11
-5 0 -4 6 3 14 14 16 24 13 13 -3z m4220 -121 c10 -11 16 -20 13 -20 -3 0 -13
9 -23 20 -10 11 -16 20 -13 20 3 0 13 -9 23 -20z m-4325 -5 c0 -8 -4 -15 -9
-15 -13 0 -22 16 -14 24 11 11 23 6 23 -9z m-48 -37 c-8 -8 -9 -4 -5 13 4 13
8 18 11 10 2 -7 -1 -18 -6 -23z m4349 15 c13 -16 12 -17 -3 -4 -10 7 -18 15
-18 17 0 8 8 3 21 -13z m-4271 -3 c0 -5 -2 -10 -4 -10 -3 0 -8 5 -11 10 -3 6
-1 10 4 10 6 0 11 -4 11 -10z m4244 -6 c3 -8 2 -12 -4 -9 -6 3 -10 10 -10 16
0 14 7 11 14 -7z m-4274 -4 c0 -5 -8 -10 -17 -10 -15 0 -16 2 -3 10 19 12 20
12 20 0z m4430 -115 c0 -8 -4 -15 -10 -15 -5 0 -10 7 -10 15 0 8 5 15 10 15 6
0 10 -7 10 -15z m204 -274 c-6 -6 -24 19 -24 34 1 6 7 1 15 -9 8 -11 12 -22 9
-25z m-29 -11 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4
11 -10z m-2563 -45 c-2 -19 -6 -35 -8 -35 -2 0 -4 16 -4 35 0 19 4 35 8 35 4
0 6 -16 4 -35z m72 -9 c7 -17 24 -59 38 -94 l24 -63 108 -1 c60 0 117 -3 127
-5 24 -7 25 -21 2 -19 -10 0 -17 -4 -16 -10 1 -7 -5 -11 -14 -10 -9 0 -18 -5
-21 -13 -3 -10 1 -12 17 -8 11 3 21 1 21 -4 0 -5 -11 -9 -25 -9 -36 0 -31 -16
7 -24 17 -3 29 -8 27 -11 -3 -2 -18 -1 -35 4 -22 6 -28 13 -27 29 3 20 0 20
-44 -8 -26 -17 -53 -30 -60 -30 -7 0 -13 -3 -13 -6 0 -17 54 -175 61 -180 5
-3 9 -10 9 -15 0 -15 -40 -1 -77 27 -17 13 -35 24 -38 24 -4 0 -20 9 -36 21
-16 11 -34 17 -40 13 -8 -4 -9 -3 -5 4 14 23 -15 11 -104 -43 -50 -31 -95 -53
-100 -50 -8 5 16 75 39 116 17 30 24 89 11 89 -17 0 -160 91 -160 102 0 8 33
11 140 14 88 2 104 4 98 10 -5 4 22 90 47 147 4 9 5 24 2 31 -12 30 23 4 37
-28z m2563 -13 c-3 -10 -5 -4 -5 12 0 17 2 24 5 18 2 -7 2 -21 0 -30z m-2487
-54 c0 -3 -7 -6 -15 -6 -17 0 -17 0 -9 22 5 13 8 14 15 3 5 -7 9 -16 9 -19z
m35 21 c-3 -5 -13 -10 -21 -10 -8 0 -14 5 -14 10 0 6 9 10 21 10 11 0 17 -4
14 -10z m-2608 -62 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-74
-94 c-7 -74 -8 -76 -13 -34 -3 25 -2 49 2 55 4 5 8 22 8 39 0 16 2 27 6 24 3
-3 2 -41 -3 -84z m2851 71 c-4 -8 -14 -15 -23 -15 -14 1 -13 3 3 15 25 19 27
19 20 0z m-141 -2 c-13 -2 -33 -2 -45 0 -13 2 -3 4 22 4 25 0 35 -2 23 -4z
m-304 -7 c-2 -2 -26 -6 -53 -9 -30 -3 -43 -1 -35 4 13 8 97 13 88 5z m394 -3
c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17 0 24 -2 18 -5z m-516 -9 c-3 -3 -12
-4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m2949 -90 c-4 -18 -10 -34 -15 -34
-4 0 -3 20 3 45 12 52 22 43 12 -11z m-2951 16 c3 -5 2 -10 -4 -10 -5 0 -13 5
-16 10 -3 6 -2 10 4 10 5 0 13 -4 16 -10z m-2315 -27 c0 -19 -3 -24 -10 -17
-6 6 -8 18 -4 27 9 24 14 21 14 -10z m2355 -1 c-3 -3 -11 0 -18 7 -9 10 -8 11
6 5 10 -3 15 -9 12 -12z m-40 -12 c-27 -12 -43 -12 -25 0 8 5 22 9 30 9 10 0
8 -3 -5 -9z m442 -52 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z
m-2801 -23 c-4 -14 -10 -25 -15 -25 -5 0 -4 13 2 30 13 35 22 32 13 -5z m5381
-27 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-2949 -3 c6 11 11
16 12 10 0 -5 -4 -16 -9 -24 -11 -17 -31 -6 -30 17 0 14 2 13 8 -3 8 -19 8
-19 19 0z m227 -45 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8
-4 11 -10z m25 -34 c0 -13 -7 -27 -16 -30 -15 -6 -54 9 -54 21 0 3 3 4 6 1 3
-4 14 2 25 13 26 26 39 24 39 -5z m-2683 -33 c-3 -3 -11 -2 -17 2 -8 5 -7 11
2 22 12 15 13 14 16 -1 2 -10 1 -20 -1 -23z m2548 27 c-3 -5 -11 -10 -16 -10
-6 0 -7 5 -4 10 3 6 11 10 16 10 6 0 7 -4 4 -10z m29 -31 c4 6 12 11 19 11 7
0 5 -7 -5 -16 -17 -17 -38 -12 -38 9 0 8 3 8 9 -2 6 -9 11 -10 15 -2z m193 5
c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m106 -14 c-3 -12 -8
-19 -11 -16 -5 6 5 36 12 36 2 0 2 -9 -1 -20z m-390 -2 c3 -8 -5 -14 -19 -14
-28 -2 -32 12 -6 19 9 3 18 5 18 6 1 0 4 -5 7 -11z m-56 -4 c-3 -3 -12 -4 -19
-1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m378 -4 c-3 -5 -12 -10 -18 -10 -7 0 -6 4
3 10 19 12 23 12 15 0z m2664 -102 c1 -5 -3 -8 -9 -8 -5 0 -10 12 -9 28 0 24
1 25 9 7 5 -11 9 -23 9 -27z m-5555 -59 c-3 -5 -11 -9 -17 -8 -9 0 -9 2 0 6 8
3 11 20 8 51 l-4 47 9 -44 c5 -24 7 -48 4 -52z m993 65 c-3 -3 -12 -4 -19 -1
-8 3 -5 6 6 6 11 1 17 -2 13 -5z m596 -1 c-13 -2 -33 -2 -45 0 -13 2 -3 4 22
4 25 0 35 -2 23 -4z m2174 -9 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2
13 -5z m866 -1 c-13 -2 -33 -2 -45 0 -13 2 -3 4 22 4 25 0 35 -2 23 -4z m444
1 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m-2504 -11 c-46 -2
-120 -2 -165 0 -46 1 -9 3 82 3 91 0 128 -2 83 -3z m464 -4 c-10 -6 -22 -20
-27 -32 l-9 -22 0 22 c-1 21 22 42 44 42 6 0 2 -4 -8 -10z m1126 4 c-7 -2 -21
-2 -30 0 -10 3 -4 5 12 5 17 0 24 -2 18 -5z m-4183 -22 c0 -5 -6 -14 -14 -20
-12 -10 -13 -8 -9 8 5 21 23 30 23 12z m1039 -50 c11 -27 21 -55 21 -61 0 -7
6 -26 14 -43 17 -40 59 -167 76 -229 7 -27 15 -48 19 -48 3 0 17 -38 31 -85
14 -47 27 -85 31 -85 3 0 11 24 18 53 7 28 21 70 31 92 10 22 31 81 46 130 14
50 35 110 46 134 11 24 17 52 15 62 -3 11 -1 17 3 14 4 -3 14 17 21 45 7 27
16 50 21 50 4 0 128 1 275 1 l268 0 -4 -328 c-1 -180 0 -403 4 -495 l8 -167
26 -3 c47 -7 -142 -20 -227 -16 l-84 3 4 -27 c3 -15 1 -25 -4 -22 -4 3 -8 16
-8 30 0 20 -5 24 -30 24 l-30 0 -1 363 0 362 -30 -95 c-17 -52 -34 -104 -39
-115 -5 -11 -19 -54 -31 -95 -12 -41 -25 -83 -30 -92 -5 -10 -9 -25 -9 -33 0
-8 -4 -15 -10 -15 -5 0 -10 -7 -10 -16 0 -18 -56 -191 -70 -216 -6 -10 -10
-25 -10 -33 0 -8 -4 -15 -10 -15 -5 0 -7 -8 -4 -17 5 -16 4 -16 -10 1 -14 17
-25 18 -99 13 -47 -3 -109 -3 -139 0 -47 5 -56 9 -65 32 -37 95 -53 141 -63
181 -6 25 -14 52 -17 60 -28 71 -57 153 -68 195 -7 28 -25 82 -40 120 -15 39
-33 93 -41 120 -11 43 -13 -4 -11 -357 1 -223 -1 -404 -5 -401 -5 2 -8 15 -8
29 l0 24 -155 0 -155 0 0 -25 c0 -17 -5 -25 -17 -24 -11 0 -13 3 -5 6 6 2 12
13 12 24 0 14 -8 19 -32 21 l-33 1 33 4 c17 2 32 9 32 14 0 6 -3 8 -7 6 -5 -3
-6 215 -3 485 l5 490 252 -1 c165 -1 253 2 258 9 12 19 23 10 44 -39z m1058
27 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m1487 -25 c-16 -12
-17 -15 -4 -24 12 -9 12 -10 -3 -5 -15 5 -64 -20 -87 -44 -3 -3 -25 -21 -50
-40 -25 -19 -52 -40 -60 -47 -8 -7 -50 -39 -92 -73 -43 -33 -77 -64 -76 -68 4
-12 -22 -52 -34 -52 -6 0 -1 11 12 25 30 32 14 32 -22 0 -32 -27 -34 -35 -14
-35 8 0 18 -5 22 -12 5 -8 2 -9 -10 -5 -14 6 143 -198 229 -296 6 -7 26 -32
45 -57 19 -25 45 -55 58 -66 12 -12 22 -27 22 -34 0 -7 7 -10 16 -6 11 4 15 2
11 -8 -6 -14 57 -93 71 -89 4 1 8 -7 8 -18 0 -10 -3 -19 -7 -19 -4 0 -5 -10
-2 -22 l5 -23 -16 22 c-16 21 -21 22 -253 22 -203 0 -238 3 -246 16 -4 8 -13
13 -18 9 -5 -3 -9 -2 -8 3 4 21 -2 34 -13 27 -7 -5 -8 -3 -3 6 4 7 4 15 -1 19
-11 8 -74 97 -74 105 0 12 -58 85 -64 81 -3 -3 -4 -2 -1 1 2 4 -4 19 -15 34
-11 16 -20 32 -20 36 0 4 -12 20 -26 35 -24 25 -27 26 -43 11 -9 -10 -32 -28
-51 -42 -18 -14 -55 -43 -82 -64 l-49 -39 2 -120 2 -120 -207 1 -207 1 -2 501
-2 500 210 0 210 0 0 -180 c0 -99 3 -180 8 -180 4 0 7 7 7 15 0 8 4 14 8 12
15 -4 83 63 76 75 -4 6 -3 8 4 4 6 -3 16 0 24 6 7 7 29 26 48 42 19 15 64 56
100 90 36 34 82 74 102 89 l37 28 260 -1 c206 0 261 2 261 12 0 7 6 4 12 -6 9
-16 7 -22 -8 -33z m566 27 c25 -1 40 -4 33 -6 -8 -4 -12 -53 -12 -163 -1 -133
1 -160 13 -164 9 -4 21 -1 28 6 7 7 27 23 43 36 17 12 46 37 65 54 149 135
231 207 252 221 19 12 70 15 291 17 147 1 270 0 273 -3 4 -5 -68 -66 -112 -95
-16 -10 -17 -13 -4 -22 8 -5 11 -13 7 -18 -5 -4 -12 -1 -17 7 -7 12 -16 9 -47
-16 -21 -17 -60 -48 -88 -69 -27 -21 -49 -44 -47 -51 2 -8 -3 -11 -10 -9 -8 3
-23 -3 -33 -12 -16 -14 -77 -63 -114 -90 -4 -3 9 -20 76 -103 6 -8 41 -52 78
-97 36 -46 69 -82 73 -81 12 4 60 -32 66 -50 5 -15 4 -15 -7 -2 -22 27 -57 53
-57 44 0 -5 10 -20 23 -34 85 -95 227 -275 227 -289 0 -8 -68 -11 -232 -11
-128 0 -243 -3 -255 -6 -14 -4 -23 -2 -23 5 0 11 -63 106 -101 151 -20 24 -21
25 -16 2 3 -13 1 -20 -5 -16 -5 3 -7 16 -4 27 4 16 -15 52 -66 129 l-71 108
-33 -25 c-18 -14 -47 -38 -65 -54 -17 -16 -43 -35 -57 -42 -15 -8 -31 -21 -36
-29 -15 -23 -20 -204 -7 -229 12 -21 11 -21 -111 -23 -68 -1 -165 -2 -216 -2
l-93 1 0 504 c1 277 1 504 1 504 69 0 359 -4 390 -5z m-2747 -30 c-7 -28 -13
-25 -13 6 0 14 4 23 9 20 5 -3 7 -15 4 -26z m1602 20 c3 -5 1 -10 -4 -10 -6 0
-11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z m-2548 -122 c-2 -24 -4 -5 -4 42
0 47 2 66 4 43 2 -24 2 -62 0 -85z m1540 70 c-2 -13 -4 -5 -4 17 -1 22 1 32 4
23 2 -10 2 -28 0 -40z m33 28 c0 -14 -4 -28 -10 -31 -6 -4 -10 7 -10 24 0 17
5 31 10 31 6 0 10 -11 10 -24z m3117 -8 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3
-3 4 -12 1 -19z m-2204 -33 c-3 -8 -9 -15 -14 -15 -10 0 -12 24 -3 33 11 11
24 -3 17 -18z m-276 -37 c-2 -13 -4 -5 -4 17 -1 22 1 32 4 23 2 -10 2 -28 0
-40z m913 31 c12 -9 11 -10 -7 -6 -13 3 -23 0 -23 -6 0 -6 -3 -8 -6 -4 -7 7 4
27 14 27 4 0 14 -5 22 -11z m-2471 -41 c0 -31 -1 -31 -10 -10 -5 13 -7 28 -3
33 10 16 14 9 13 -23z m28 10 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1
-19z m202 -28 l-1 -25 -8 25 c-4 14 -8 32 -9 40 -1 13 0 13 9 0 5 -8 9 -26 9
-40z m31 15 c0 -5 -5 -3 -10 5 -5 8 -10 20 -10 25 0 6 5 3 10 -5 5 -8 10 -19
10 -25z m637 -27 c-2 -13 -4 -3 -4 22 0 25 2 35 4 23 2 -13 2 -33 0 -45z
m1740 0 c-2 -13 -4 -3 -4 22 0 25 2 35 4 23 2 -13 2 -33 0 -45z m1313 47 c-7
-9 -15 -13 -17 -11 -7 7 7 26 19 26 6 0 6 -6 -2 -15z m-2156 -9 c-6 -15 -34
-31 -34 -19 0 5 30 32 37 33 1 0 0 -6 -3 -14z m603 -11 c-23 -22 -33 -18 -12
5 10 11 20 18 23 16 2 -3 -3 -12 -11 -21z m-659 1 c-7 -8 -15 -12 -17 -11 -5
6 10 25 20 25 5 0 4 -6 -3 -14z m-1531 -28 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13
3 -3 4 -12 1 -19z m3703 -11 c11 -5 9 -6 -4 -4 -11 1 -21 9 -23 17 -3 10 -2
11 4 4 4 -6 15 -14 23 -17z m-2170 -1 c0 -2 -7 -7 -16 -10 -8 -3 -12 -2 -9 4
6 10 25 14 25 6z m2787 -18 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1
-19z m-2970 -50 c-2 -13 -4 -3 -4 22 0 25 2 35 4 23 2 -13 2 -33 0 -45z m114
23 l-21 -21 0 21 c0 11 4 18 9 15 5 -3 12 2 16 12 5 11 9 13 12 5 2 -6 -5 -21
-16 -32z m1539 -6 c-7 -9 -15 -13 -17 -11 -7 7 7 26 19 26 6 0 6 -6 -2 -15z
m-4386 -44 c-4 -17 -9 -30 -11 -27 -3 2 -2 19 2 36 9 41 17 33 9 -9z m1215 2
c0 -25 -1 -26 -9 -8 -12 27 -12 35 0 35 6 0 10 -12 9 -27z m3756 17 c3 -6 -1
-7 -9 -4 -18 7 -21 14 -7 14 6 0 13 -4 16 -10z m-3583 -32 c-8 -8 -9 -4 -5 13
4 13 8 18 11 10 2 -7 -1 -18 -6 -23z m-865 -40 c-2 -13 -4 -3 -4 22 0 25 2 35
4 23 2 -13 2 -33 0 -45z m5180 30 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2
-19 0 -25z m20 0 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m-2972
12 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z
m-2748 -52 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m5741 -48 l0
-25 -8 25 c-4 14 -8 36 -8 50 l0 25 8 -25 c4 -14 8 -36 8 -50z m-28 11 c0 -32
-6 -24 -14 19 -4 25 -3 31 4 20 5 -8 10 -26 10 -39z m-4436 -15 c-3 -21 -9
-35 -11 -32 -3 3 -2 21 1 42 4 20 10 34 12 31 3 -3 2 -21 -2 -41z m45 -25 c1
-48 -5 -36 -13 24 -4 34 -3 43 3 30 5 -11 10 -35 10 -54z m2468 -53 c-2 -24
-4 -5 -4 42 0 47 2 66 4 43 2 -24 2 -62 0 -85z m20 0 c-2 -24 -4 -5 -4 42 0
47 2 66 4 43 2 -24 2 -62 0 -85z m-2570 80 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13
3 -3 4 -12 1 -19z m110 0 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z
m3450 0 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-3120 -20 c-3
-7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m-377 -2 c0 -3 -4 -8 -10
-11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z m4417 -43 c-3 -10 -5
-2 -5 17 0 19 2 27 5 18 2 -10 2 -26 0 -35z m-5200 -35 c-2 -13 -4 -3 -4 22 0
25 2 35 4 23 2 -13 2 -33 0 -45z m1163 47 c0 -8 -2 -15 -4 -15 -2 0 -6 7 -10
15 -3 8 -1 15 4 15 6 0 10 -7 10 -15z m-1683 -57 c-3 -7 -5 -2 -5 12 0 14 2
19 5 13 2 -7 2 -19 0 -25z m1300 -15 c-3 -10 -5 -2 -5 17 0 19 2 27 5 18 2
-10 2 -26 0 -35z m2068 -4 c11 -16 1 -19 -13 -3 -7 8 -8 14 -3 14 5 0 13 -5
16 -11z m1519 -13 c-8 -20 -24 -21 -24 0 0 8 5 12 10 9 6 -3 10 -1 10 6 0 7 2
10 5 7 3 -3 3 -13 -1 -22z m-1508 -44 c-10 -11 -16 -12 -16 -4 0 7 5 12 10 12
6 0 10 8 11 18 0 11 2 13 6 4 3 -8 -2 -21 -11 -30z m-2859 -254 c-1 -46 -3 -9
-3 82 0 91 2 128 3 83 2 -46 2 -120 0 -165z m3270 120 c-2 -24 -4 -5 -4 42 0
47 2 66 4 43 2 -24 2 -62 0 -85z m20 0 c-2 -24 -4 -5 -4 42 0 47 2 66 4 43 2
-24 2 -62 0 -85z m1152 58 c-9 -8 -10 -7 -5 7 3 10 7 24 7 30 1 7 3 4 6 -7 3
-10 -1 -23 -8 -30z m-1517 -10 c11 -20 10 -20 -8 -6 -23 18 -34 32 -34 44 0
13 29 -14 42 -38z m-1841 -2 c-5 -16 -10 -21 -10 -12 -1 18 10 51 15 45 2 -1
-1 -16 -5 -33z m-617 10 c3 -8 2 -12 -4 -9 -6 3 -10 10 -10 16 0 14 7 11 14
-7z m1926 -4 c0 -5 -2 -10 -4 -10 -3 0 -8 5 -11 10 -3 6 -1 10 4 10 6 0 11 -4
11 -10z m1507 -32 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m47
-27 c-7 -9 -24 13 -24 32 0 21 1 21 13 -3 8 -14 12 -27 11 -29z m553 43 c-3
-3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m28 -13 c-3 -6 -11 -11 -16
-11 -5 0 -4 6 3 14 14 16 24 13 13 -3z m-1525 -11 c0 -5 -4 -10 -10 -10 -5 0
-10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m-2531 -40 c0 -10 -3 -8 -9 5
-12 27 -12 43 0 25 5 -8 9 -22 9 -30z m2491 30 c0 -5 -2 -10 -4 -10 -3 0 -8 5
-11 10 -3 6 -1 10 4 10 6 0 11 -4 11 -10z m-1906 -25 c-4 -8 -8 -15 -10 -15
-2 0 -4 7 -4 15 0 8 4 15 10 15 5 0 7 -7 4 -15z m1240 -1 c3 -8 2 -12 -4 -9
-6 3 -10 10 -10 16 0 14 7 11 14 -7z m1643 -10 c-3 -3 -12 -4 -19 -1 -8 3 -5
6 6 6 11 1 17 -2 13 -5z m51 -24 c-7 -10 -14 -18 -15 -16 -6 6 9 36 18 36 5 0
4 -9 -3 -20z m-1519 -55 c0 -5 -4 -3 -9 5 -5 8 -9 22 -9 30 0 16 17 -16 18
-35z m2096 25 c10 -11 16 -20 13 -20 -3 0 -13 9 -23 20 -10 11 -16 20 -13 20
3 0 13 -9 23 -20z m-2065 -15 c7 -9 8 -15 2 -15 -5 0 -12 7 -16 15 -3 8 -4 15
-2 15 2 0 9 -7 16 -15z m1500 -5 c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8
10 11 10 2 0 4 -4 4 -10z m610 -16 c0 -8 -5 -12 -10 -9 -6 4 -8 11 -5 16 9 14
15 11 15 -7z m-3619 -97 c-13 -13 -15 11 -4 40 7 16 8 15 11 -6 2 -13 -1 -28
-7 -34z m2199 28 c0 -14 -4 -25 -9 -25 -5 0 -11 -6 -14 -12 -2 -7 -2 -2 0 10
2 13 0 21 -4 19 -5 -3 -9 3 -9 14 0 12 7 19 18 19 13 0 18 -8 18 -25z m-635
-5 c3 -5 -1 -10 -10 -10 -9 0 -13 5 -10 10 3 6 8 10 10 10 2 0 7 -4 10 -10z
m-2573 -52 c2 -20 0 -34 -4 -32 -4 3 -8 24 -7 47 1 47 6 41 11 -15z m1555 -15
c-2 -16 -4 -5 -4 22 0 28 2 40 4 28 2 -13 2 -35 0 -50z m1733 22 c0 -25 -3
-45 -8 -45 -4 0 -6 20 -4 45 2 25 6 45 8 45 2 0 4 -20 4 -45z m17 -17 c-2 -13
-4 -3 -4 22 0 25 2 35 4 23 2 -13 2 -33 0 -45z m-707 22 c0 -5 -4 -10 -10 -10
-5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m-1573 -32 c-3 -8 -6 -5
-6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m1624 -40 c0 -7 2 -23 3 -36 2 -14 -1
-19 -6 -14 -13 13 -18 62 -7 62 5 0 9 -6 10 -12z m1536 -8 c1 -16 -4 -20 -28
-20 -16 0 -29 5 -29 11 0 7 10 9 27 4 23 -5 25 -4 14 9 -11 13 -11 16 1 16 7
0 14 -9 15 -20z m-4154 -7 c-7 -2 -13 -12 -14 -21 0 -14 -2 -13 -9 3 -7 17 -9
16 -10 -10 -2 -19 -4 -23 -7 -12 -7 29 4 47 29 46 13 0 17 -3 11 -6z m314 -25
c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m530 10 c-3 -8 -6 -5 -6
6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m335 -2 c3 -16 1 -23 -7 -19 -7 2 -11 13
-8 24 7 25 10 24 15 -5z m334 -12 c8 3 14 1 14 -4 0 -6 -7 -10 -16 -10 -11 0
-14 -5 -10 -16 19 -50 56 -166 56 -177 0 -7 9 -18 20 -25 11 -7 20 -18 20 -25
0 -8 -4 -7 -11 3 -15 22 -1 -44 21 -95 9 -22 20 -61 24 -87 4 -28 14 -52 24
-58 30 -18 -7 -30 -82 -28 -69 3 -69 3 -73 33 -7 53 -33 65 -111 49 -23 -5
-33 -15 -46 -46 l-15 -41 -57 5 c-43 4 -57 1 -61 -10 -5 -12 -7 -12 -15 2 -11
20 -32 21 -24 1 3 -8 2 -15 -3 -15 -11 0 -21 53 -12 60 5 3 11 12 14 20 4 10
6 8 6 -7 1 -12 -5 -24 -11 -27 -7 -3 -4 -5 6 -3 13 1 24 16 34 47 8 25 18 47
22 50 4 3 10 23 14 45 9 47 30 114 64 205 14 36 28 79 31 95 7 29 8 30 81 35
74 5 75 5 74 33 -1 18 0 20 3 6 3 -13 10 -18 19 -15z m44 21 c0 -8 -4 -15 -8
-15 -5 0 -9 7 -9 15 0 8 4 15 9 15 4 0 8 -7 8 -15z m2160 5 c0 -5 -2 -10 -4
-10 -3 0 -8 5 -11 10 -3 6 -1 10 4 10 6 0 11 -4 11 -10z m-2977 -7 c-13 -2
-33 -2 -45 0 -13 2 -3 4 22 4 25 0 35 -2 23 -4z m640 0 c-13 -2 -33 -2 -45 0
-13 2 -3 4 22 4 25 0 35 -2 23 -4z m814 1 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6
11 1 17 -2 13 -5z m-1317 -14 c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10
11 10 2 0 4 -4 4 -10z m2230 0 c0 -5 -2 -10 -4 -10 -3 0 -8 5 -11 10 -3 6 -1
10 4 10 6 0 11 -4 11 -10z m1567 -17 c-7 -6 -46 10 -41 18 3 5 14 3 24 -3 11
-7 18 -13 17 -15z m-2487 7 c-19 -13 -30 -13 -30 0 0 6 10 10 23 10 18 0 19
-2 7 -10z m470 -10 c0 -11 3 -20 8 -20 4 0 7 -24 7 -54 0 -30 -2 -54 -5 -54
-35 3 -230 -6 -217 -9 14 -4 16 -8 6 -19 -6 -8 -8 -14 -3 -14 5 0 2 -5 -6 -10
-10 -7 11 -10 70 -10 47 -1 100 -3 118 -5 35 -3 57 -15 29 -15 -13 0 -17 -9
-17 -36 0 -21 4 -33 10 -29 6 3 10 0 10 -7 0 -7 3 -24 7 -37 4 -17 3 -22 -5
-17 -7 4 -12 16 -12 26 0 16 -4 17 -29 10 -16 -4 -32 -6 -35 -3 -2 3 -37 2
-75 -2 l-71 -7 0 -39 0 -39 109 0 109 0 4 -55 c3 -49 1 -55 -17 -55 -11 0 -90
0 -175 -1 -218 -1 -205 -2 -185 18 15 14 16 43 14 242 l-3 226 169 1 c153 0
170 2 169 17 -1 9 2 17 7 17 5 0 9 -9 9 -20z m1525 10 c-3 -5 -13 -10 -21 -10
-8 0 -14 5 -14 10 0 6 9 10 21 10 11 0 17 -4 14 -10z m-4737 -130 c-1 -28 -2
-25 -8 15 -5 28 -8 66 -8 85 1 28 2 25 8 -15 5 -27 8 -66 8 -85z m1279 124
c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m600 -26 c-3 -7 -5 -2
-5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m758 22 c-17 -7 -14 -9 13 -9 37 -1
102 -28 102 -42 0 -5 9 -18 20 -29 26 -26 27 -80 1 -80 -10 0 -39 -3 -64 -6
-43 -6 -47 -5 -56 19 -12 30 -43 42 -71 27 -34 -18 -19 -32 71 -62 87 -30 96
-33 142 -43 16 -3 27 -12 27 -22 0 -15 -1 -15 -18 0 -10 10 -25 17 -33 17 -11
-1 -11 -3 2 -13 24 -19 40 -75 33 -121 -14 -88 -53 -129 -142 -146 -31 -6 -66
-14 -77 -16 -15 -4 -16 -3 -6 4 9 7 0 11 -33 16 -52 8 -116 60 -116 94 0 11
-5 22 -11 24 -6 2 -8 14 -4 31 6 23 12 27 44 27 20 0 46 3 59 6 18 5 25 0 37
-30 9 -20 20 -34 26 -31 5 4 8 1 7 -7 -2 -9 6 -12 27 -10 34 4 55 18 55 38 0
17 -57 57 -74 51 -8 -3 -17 -2 -22 3 -5 4 -25 13 -45 19 -59 19 -92 61 -97
125 -3 44 0 62 17 89 22 36 72 67 113 68 12 0 32 4 43 9 11 5 27 9 35 9 9 0 8
-4 -5 -9z m794 -9 c135 1 188 -11 210 -48 9 -16 10 -14 11 14 0 17 -3 33 -7
36 -5 2 -3 3 3 1 6 -1 18 3 25 9 11 10 11 9 0 -5 -9 -13 -11 -40 -6 -106 8
-96 2 -118 -41 -159 -23 -21 -23 -23 -6 -52 9 -17 20 -31 25 -31 4 0 7 -6 7
-12 0 -7 13 -41 30 -75 16 -35 25 -63 19 -63 -6 0 -7 -4 -4 -10 3 -5 1 -10 -4
-10 -6 0 -11 5 -11 10 0 7 -22 8 -63 4 l-63 -6 -44 88 c-42 83 -63 113 -83
114 -5 0 -7 -44 -6 -97 l3 -98 -89 2 c-48 2 -91 5 -93 8 -3 3 4 5 16 5 22 0
22 1 22 229 0 174 -3 231 -12 234 -8 3 -6 6 5 6 9 1 17 9 18 19 0 11 2 12 6 4
4 -10 36 -13 132 -11z m188 13 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2
13 -5z m396 -1 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m157 -5
c0 -4 -9 -8 -20 -8 -11 0 -20 4 -20 9 0 6 9 9 20 8 11 -1 20 -5 20 -9z m875
-8 c90 0 166 -3 169 -8 2 -4 6 -30 7 -57 l3 -50 -107 -3 -107 -3 0 -29 0 -30
73 -1 c39 -1 89 -2 110 -2 20 0 37 -4 37 -9 0 -4 -4 -8 -9 -8 -18 0 -22 -41
-7 -71 13 -26 13 -29 1 -19 -8 7 -15 9 -15 4 0 -5 -44 -9 -97 -9 l-98 0 -3
-42 -3 -43 115 0 116 0 0 -54 0 -54 -82 -7 c-46 -3 -127 -5 -181 -3 l-98 3 0
240 c0 265 0 286 8 268 3 -10 47 -13 168 -13z m-4312 -5 c82 -4 106 -9 140
-30 23 -14 38 -25 33 -25 -5 0 -2 -8 7 -18 29 -32 39 -77 39 -186 1 -75 -2
-111 -10 -114 -7 -2 -12 -10 -12 -18 0 -8 -17 -30 -37 -49 -28 -26 -51 -36
-98 -44 -64 -11 -203 -15 -227 -6 -10 4 -12 51 -10 239 l3 235 -28 4 c-20 3
-15 5 17 6 36 2 41 4 25 11 -14 7 -9 8 20 5 22 -3 84 -7 138 -10z m1045 -55
c2 -30 9 -58 15 -62 13 -8 7 -9 -88 -12 l-60 -1 -5 -190 c-3 -104 -7 -184 -8
-177 -1 10 -18 13 -64 10 l-63 -3 0 180 0 180 -65 1 -65 1 -3 48 c-6 96 -20
91 205 85 l198 -5 3 -55z m2337 60 c-3 -6 5 -10 19 -10 24 0 24 -1 11 -27 -7
-16 -21 -55 -31 -88 -9 -33 -26 -83 -36 -112 -11 -29 -17 -57 -13 -62 3 -6 2
-11 -4 -11 -6 0 -18 -26 -26 -57 -9 -32 -20 -67 -25 -78 -4 -11 -10 -27 -13
-36 -4 -12 -20 -15 -83 -14 l-78 2 -8 34 c-5 19 -12 41 -17 49 -5 9 -12 36
-16 60 -4 25 -11 50 -15 55 -8 10 -64 173 -73 210 -4 17 -5 16 -6 -5 -1 -17
-4 -21 -12 -13 -8 8 -8 17 1 33 9 16 9 25 1 33 -6 6 -11 17 -11 24 0 11 18 13
77 11 l76 -3 19 -65 c10 -36 20 -79 22 -95 2 -17 11 -52 20 -78 9 -26 16 -54
16 -62 0 -8 5 -15 11 -15 6 0 9 6 6 14 -3 7 -1 18 5 24 5 5 10 26 11 46 1 20
4 36 7 36 6 0 30 88 35 130 1 8 7 27 13 42 10 24 18 27 64 31 29 2 54 4 56 5
2 1 0 -2 -3 -8z m570 -6 c44 -6 125 -97 125 -139 0 -12 -58 -32 -110 -37 -19
-2 -26 2 -28 18 -2 12 -14 26 -28 33 -30 13 -57 15 -50 2 3 -5 -2 -8 -11 -7
-30 2 -44 -43 -40 -126 4 -87 22 -118 66 -118 38 1 61 23 68 64 3 20 7 36 8
36 2 0 16 -7 31 -15 16 -8 37 -15 47 -15 10 0 27 -4 37 -10 16 -9 17 -13 3
-51 -22 -66 -30 -77 -79 -105 -32 -19 -60 -27 -97 -27 -92 -2 -149 25 -203 95
-22 28 -37 120 -31 190 10 115 58 185 147 212 42 13 63 13 145 0z m165 6 c0
-5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m-3591
-14 c7 -8 13 -22 15 -32 7 -34 37 -139 46 -159 5 -11 28 -77 51 -147 l41 -128
42 -1 c22 -1 33 -3 24 -6 -10 -2 -18 -11 -18 -19 0 -8 -4 -14 -10 -14 -5 0 -7
7 -4 15 5 12 -5 13 -63 8 -37 -3 -71 -11 -75 -17 -5 -7 -8 -5 -8 5 0 10 -7 16
-17 15 -13 -1 -21 10 -27 37 l-10 37 -65 0 c-62 0 -67 -2 -78 -27 -7 -15 -13
-33 -13 -41 0 -9 -6 -12 -16 -8 -9 3 -50 7 -92 7 -42 1 -68 4 -56 6 15 3 24
17 34 53 8 28 17 50 22 50 4 0 8 8 8 19 0 25 61 215 71 221 4 3 11 26 15 50
11 79 24 90 103 90 47 0 72 -4 80 -14z m828 -8 c-3 -8 -6 -5 -6 6 -1 11 2 17
5 13 3 -3 4 -12 1 -19z m1780 -10 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2
-19 0 -25z m458 -218 l0 -245 -68 -3 -67 -3 -1 221 c-1 121 -1 231 -1 245 0
14 0 27 1 30 1 3 31 5 69 3 l67 -3 0 -245z m1434 166 c-2 -20 -2 -20 -6 2 -2
12 -7 20 -11 18 -4 -2 -8 12 -9 33 l-2 36 15 -34 c8 -18 13 -43 13 -55z
m-5742 42 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m1343 18 c0
-3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z m4357
-28 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-4388 -55 l-2 -38
-7 40 c-4 22 -8 31 -9 20 l-2 -20 -8 20 c-5 11 -6 26 -4 32 10 25 33 -15 32
-54z m1941 63 c0 -9 -30 -14 -35 -6 -4 6 3 10 14 10 12 0 21 -2 21 -4z m890
-16 c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z
m-4143 -37 c-3 -10 -5 -4 -5 12 0 17 2 24 5 18 2 -7 2 -21 0 -30z m1343 22 c0
-8 -4 -15 -10 -15 -5 0 -7 7 -4 15 4 8 8 15 10 15 2 0 4 -7 4 -15z m1907 -47
c-2 -13 -4 -3 -4 22 0 25 2 35 4 23 2 -13 2 -33 0 -45z m1112 55 c0 -5 -4 -17
-9 -28 -8 -18 -9 -17 -9 8 -1 15 4 27 9 27 6 0 10 -3 9 -7z m435 -9 c3 -8 2
-12 -4 -9 -6 3 -10 10 -10 16 0 14 7 11 14 -7z m-417 -26 c-3 -8 -6 -5 -6 6
-1 11 2 17 5 13 3 -3 4 -12 1 -19z m-2566 -25 c-8 -15 -10 -15 -11 -2 0 17 10
32 18 25 2 -3 -1 -13 -7 -23z m797 -9 c2 -1 -8 -1 -21 0 -15 0 -23 6 -20 14 4
10 9 10 22 0 9 -7 17 -13 19 -14z m3099 -26 c-2 -13 -4 -5 -4 17 -1 22 1 32 4
23 2 -10 2 -28 0 -40z m-2497 22 c0 -5 -8 -10 -17 -10 -15 0 -16 2 -3 10 19
12 20 12 20 0z m2000 0 c0 -5 -8 -10 -17 -10 -15 0 -16 2 -3 10 19 12 20 12
20 0z m-5213 -47 c-3 -10 -5 -2 -5 17 0 19 2 27 5 18 2 -10 2 -26 0 -35z
m3683 8 c0 -22 -4 -42 -9 -45 -5 -3 -8 15 -7 39 1 55 16 60 16 6z m237 -5 c-1
-24 -8 -49 -14 -55 -7 -6 -13 -10 -13 -7 0 14 22 106 25 106 2 0 3 -20 2 -44z
m-1120 19 c-8 -8 -29 -13 -45 -12 -37 2 -29 14 13 20 17 2 34 5 38 6 5 0 2 -6
-6 -14z m-1130 -27 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m478
22 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z
m1065 0 c0 -5 -4 -10 -9 -10 -6 0 -13 5 -16 10 -3 6 1 10 9 10 9 0 16 -4 16
-10z m667 -22 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m483 11
c0 -11 -4 -18 -10 -14 -5 3 -7 12 -3 20 7 21 13 19 13 -6z m828 14 c-15 -2
-42 -2 -60 0 -18 2 -6 4 27 4 33 0 48 -2 33 -4z m-4231 -40 c-3 -10 -5 -4 -5
12 0 17 2 24 5 18 2 -7 2 -21 0 -30z m383 16 c0 -6 -4 -7 -10 -4 -5 3 -10 11
-10 16 0 6 5 7 10 4 6 -3 10 -11 10 -16z m100 12 c0 -12 -20 -25 -27 -18 -7 7
6 27 18 27 5 0 9 -4 9 -9z m3365 -1 c-3 -5 -16 -10 -28 -10 -18 0 -19 2 -7 10
20 13 43 13 35 0z m32 -32 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0
-25z m-2074 15 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m1947 3
c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z m71
-6 c16 0 29 -4 29 -9 0 -4 -17 -7 -37 -5 -21 1 -41 -2 -45 -9 -4 -7 -6 -2 -5
11 1 15 6 21 15 17 7 -3 27 -5 43 -5z m-221 -64 c0 -52 -6 -43 -13 18 -3 30
-1 43 4 35 5 -8 9 -32 9 -53z m-3193 -1 c0 -31 -3 -51 -7 -45 -3 5 -5 29 -4
53 3 49 3 47 7 47 2 0 4 -25 4 -55z m4340 33 c-3 -8 -6 -5 -6 6 -1 11 2 17 5
13 3 -3 4 -12 1 -19z m-5190 -50 c-2 -13 -4 -3 -4 22 0 25 2 35 4 23 2 -13 2
-33 0 -45z m1260 30 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z
m380 0 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m2508 2 c3 -5 1
-10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z m-1015 -10 c0
-5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z m-1503 -32
c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m319 -5 c-7 -7 -26 7
-26 19 0 6 6 6 15 -2 9 -7 13 -15 11 -17z m1274 7 c0 -5 -5 -10 -11 -10 -5 0
-7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z m350 -15 c0 -12 -19 -12 -23 0 -4
9 -1 12 9 8 7 -3 14 -7 14 -8z m-2623 -47 c-2 -13 -4 -5 -4 17 -1 22 1 32 4
23 2 -10 2 -28 0 -40z m3110 30 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12
1 -19z m440 -25 c-3 -10 -5 -4 -5 12 0 17 2 24 5 18 2 -7 2 -21 0 -30z m-2657
18 c0 -6 -4 -13 -10 -16 -5 -3 -10 1 -10 9 0 9 5 16 10 16 6 0 10 -4 10 -9z
m2009 -46 c0 -5 -4 -3 -9 5 -5 8 -9 22 -9 30 0 16 17 -16 18 -35z m-1995 12
c-3 -8 -12 -18 -20 -21 -11 -4 -11 0 2 20 18 26 28 27 18 1z m256 13 c0 -5 -4
-10 -9 -10 -6 0 -13 5 -16 10 -3 6 1 10 9 10 9 0 16 -4 16 -10z m1430 6 c0 -3
-4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z m-1253 -28
c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m880 -10 c-3 -8 -6 -5
-6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-3646 -25 c-8 -15 -10 -15 -11 -2 0
17 10 32 18 25 2 -3 -1 -13 -7 -23z m26 -10 c-3 -10 -5 -4 -5 12 0 17 2 24 5
18 2 -7 2 -21 0 -30z m435 -15 c2 -21 0 -38 -4 -38 -4 0 -8 21 -7 48 1 52 6
48 11 -10z m938 42 c0 -5 -4 -10 -9 -10 -6 0 -13 5 -16 10 -3 6 1 10 9 10 9 0
16 -4 16 -10z m27 -22 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z
m4160 -15 c-3 -10 -5 -4 -5 12 0 17 2 24 5 18 2 -7 2 -21 0 -30z m-1850 -15
c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m-2330 0 c-3 -8 -6 -5
-6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m2027 6 c3 -8 2 -12 -4 -9 -6 3 -10
10 -10 16 0 14 7 11 14 -7z m-2556 -16 c-2 -6 -10 -14 -16 -16 -7 -2 -10 2 -6
12 7 18 28 22 22 4z m502 -3 c0 -8 -4 -15 -10 -15 -5 0 -7 7 -4 15 4 8 8 15
10 15 2 0 4 -7 4 -15z m4214 -45 c-20 -79 -23 -82 -16 -20 4 44 20 85 29 76 1
0 -5 -26 -13 -56z m-5567 18 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1
-19z m1069 -35 c11 -8 12 -13 4 -18 -16 -10 -20 -3 -24 36 -2 19 -1 25 1 14 2
-11 11 -25 19 -32z m1091 35 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1
-19z m1193 -38 l-11 -25 6 25 c2 14 5 34 6 45 2 19 2 19 6 0 2 -12 -1 -32 -7
-45z m40 56 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2
10 -4z m-1560 -31 c-7 -9 -23 -21 -34 -27 -16 -8 -14 -3 8 21 29 31 51 36 26
6z m-1813 -7 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m3433 1 c0
-6 -4 -7 -10 -4 -5 3 -10 11 -10 16 0 6 5 7 10 4 6 -3 10 -11 10 -16z m-2645
1 c-3 -5 -10 -10 -16 -10 -5 0 -9 5 -9 10 0 6 7 10 16 10 8 0 12 -4 9 -10z
m767 -15 c3 -14 1 -25 -3 -25 -5 0 -9 11 -9 25 0 14 2 25 4 25 2 0 6 -11 8
-25z m25 -7 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m350 10 c-3
-8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m1448 1 c4 -11 4 -23 1 -26
-3 -4 -6 2 -7 13 0 18 -1 18 -9 -1 -8 -18 -9 -17 -9 8 -1 32 15 36 24 6z
m-2730 -3 c17 -1 -30 -4 -102 -4 -73 -1 -133 1 -133 6 0 6 165 6 235 -2z
m3075 4 c0 -5 -4 -10 -9 -10 -6 0 -13 5 -16 10 -3 6 1 10 9 10 9 0 16 -4 16
-10z m520 0 c0 -5 -10 -10 -22 -9 -22 0 -22 1 -3 9 11 5 21 9 23 9 1 1 2 -3 2
-9z m505 0 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11
-10z m-3725 -21 c0 -5 -9 -9 -20 -9 -17 0 -19 2 -8 14 13 14 28 12 28 -5z
m813 9 c3 -8 -5 -14 -19 -14 -18 -2 -20 1 -11 12 15 17 24 17 30 2z m180 5
c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17 0 24 -2 18 -5z m60 0 c-7 -2 -21 -2
-30 0 -10 3 -4 5 12 5 17 0 24 -2 18 -5z m360 0 c-7 -2 -19 -2 -25 0 -7 3 -2
5 12 5 14 0 19 -2 13 -5z m350 0 c-13 -2 -33 -2 -45 0 -13 2 -3 4 22 4 25 0
35 -2 23 -4z m404 -15 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z
m223 6 c0 -8 -4 -12 -10 -9 -5 3 -10 10 -10 16 0 5 5 9 10 9 6 0 10 -7 10 -16z
m93 9 c-13 -2 -33 -2 -45 0 -13 2 -3 4 22 4 25 0 35 -2 23 -4z m405 0 c-10 -2
-26 -2 -35 0 -10 3 -2 5 17 5 19 0 27 -2 18 -5z m276 -8 c-4 -8 -7 -15 -9 -15
-2 0 -5 7 -9 15 -3 9 0 15 9 15 9 0 12 -6 9 -15z m264 8 c-10 -2 -26 -2 -35 0
-10 3 -2 5 17 5 19 0 27 -2 18 -5z m535 0 c-34 -2 -93 -2 -130 0 -37 2 -9 3
62 3 72 0 102 -1 68 -3z m-2638 -13 c-3 -5 -12 -10 -18 -10 -7 0 -6 4 3 10 19
12 23 12 15 0z m1205 0 c0 -5 -2 -10 -4 -10 -3 0 -8 5 -11 10 -3 6 -1 10 4 10
6 0 11 -4 11 -10z m-3107 -7 c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17 0 24 -2
18 -5z m210 0 c-18 -2 -48 -2 -65 0 -18 2 -4 4 32 4 36 0 50 -2 33 -4z m220 0
c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17 0 24 -2 18 -5z m1074 1 c-3 -3 -12 -4
-19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m480 0 c-3 -3 -12 -4 -19 -1 -8 3 -5
6 6 6 11 1 17 -2 13 -5z m326 -1 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19
-2 13 -5z m1480 0 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m194
1 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m341 -1 c-10 -2 -26
-2 -35 0 -10 3 -2 5 17 5 19 0 27 -2 18 -5z m-4728 -152 c0 -28 -17 3 -23 39
l-6 35 14 -30 c8 -16 14 -37 15 -44z m24 22 c-10 -40 -14 -41 -14 -5 0 18 5
32 10 32 6 0 8 -11 4 -27z m5383 5 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4
-12 1 -19z m34 -15 c-8 -15 -10 -15 -11 -2 0 17 10 32 18 25 2 -3 -1 -13 -7
-23z m-5404 -25 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-10
-40 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m5390 0 c-3 -8 -6
-5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-5300 -155 c-3 -10 -5 -4 -5 12 0
17 2 24 5 18 2 -7 2 -21 0 -30z m5247 22 c-4 -8 -8 -15 -10 -15 -2 0 -4 7 -4
15 0 8 4 15 10 15 5 0 7 -7 4 -15z m-5194 -155 c0 -5 -4 -10 -10 -10 -5 0 -10
5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m17 -32 c-3 -7 -5 -2 -5 12 0 14 2
19 5 13 2 -7 2 -19 0 -25z m93 -128 c0 -5 -4 -10 -9 -10 -6 0 -13 5 -16 10 -3
6 1 10 9 10 9 0 16 -4 16 -10z m4887 -27 c0 -21 -2 -31 -5 -23 -3 8 -11 19
-18 23 -20 12 -17 37 4 37 14 0 18 -8 19 -37z m-4844 -88 c6 -16 3 -15 -13 5
-11 14 -20 29 -20 33 0 13 25 -16 33 -38z m4797 41 c0 -2 -8 -10 -17 -17 -16
-13 -17 -12 -4 4 13 16 21 21 21 13z m-4 -54 c-17 -16 -18 -16 -5 5 7 12 15
20 18 17 3 -2 -3 -12 -13 -22z m-4526 -304 c0 -19 -2 -20 -10 -8 -13 19 -13
30 0 30 6 0 10 -10 10 -22z m127 -140 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3
4 -12 1 -19z m3980 -25 c-3 -10 -5 -2 -5 17 0 19 2 27 5 18 2 -10 2 -26 0 -35z
m-3950 -15 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m69 -55 c-7
-7 -26 7 -26 19 0 6 6 6 15 -2 9 -7 13 -15 11 -17z m104 -34 c0 -11 -4 -17
-10 -14 -5 3 -10 15 -10 26 0 11 5 17 10 14 6 -3 10 -15 10 -26z m3687 -1 c-3
-8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-162 -98 c3 -6 -1 -7 -9 -4
-18 7 -21 14 -7 14 6 0 13 -4 16 -10z m-3395 -30 c0 -5 -4 -10 -10 -10 -5 0
-10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m3360 0 c0 -5 -5 -10 -11 -10
-5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z m-3300 -50 c18 -12 2 -12 -25
0 -13 6 -15 9 -5 9 8 0 22 -4 30 -9z m120 -80 c8 -5 11 -10 5 -10 -5 0 -17 5
-25 10 -8 5 -10 10 -5 10 6 0 17 -5 25 -10z m2980 -10 c0 -5 -8 -10 -17 -10
-15 0 -16 2 -3 10 19 12 20 12 20 0z m-2825 -70 c4 -6 11 -8 16 -5 5 4 6 -2 2
-11 -4 -11 -8 -13 -11 -6 -2 7 -13 12 -23 12 -11 0 -17 5 -14 10 8 13 22 13
30 0z m2602 4 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m-2532
-14 c3 -6 -1 -7 -9 -4 -18 7 -21 14 -7 14 6 0 13 -4 16 -10z m-10 -30 c8 -13
-5 -13 -25 0 -13 8 -13 10 2 10 9 0 20 -4 23 -10z m2562 -6 c-3 -3 -12 -4 -19
-1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m-2457 -34 c24 -15 7 -18 -25 -4 -23 10
-25 13 -10 13 11 1 27 -3 35 -9z m2373 3 c-13 -2 -23 -9 -23 -14 0 -13 -17
-11 -23 4 -3 8 7 12 32 13 20 1 26 -1 14 -3z m-2306 -9 c-3 -3 -12 -4 -19 -1
-8 3 -5 6 6 6 11 1 17 -2 13 -5z m2246 -11 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12
5 14 0 19 -2 13 -5z m-2268 -13 c3 -5 2 -10 -4 -10 -5 0 -13 5 -16 10 -3 6 -2
10 4 10 5 0 13 -4 16 -10z m2235 -10 c0 -5 -8 -10 -17 -10 -15 0 -16 2 -3 10
19 12 20 12 20 0z m-2090 -40 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5
10 10 10 6 0 10 -4 10 -10z m68 -10 c-14 -22 -24 -25 -33 -10 -3 6 1 10 10 10
9 0 13 5 10 10 -3 6 1 10 9 10 14 0 14 -3 4 -20z m1899 4 c-3 -3 -12 -4 -19
-1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m-97 -24 c0 -5 -5 -10 -11 -10 -5 0 -7 5
-4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z m-127 -52 c-6 -11 -41 -10 -48 2 -3 5 7
8 24 7 16 -1 27 -5 24 -9z m-90 -5 c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17 0
24 -2 18 -5z m-1288 -13 c-27 -12 -43 -12 -25 0 8 5 22 9 30 9 10 0 8 -3 -5
-9z m360 -65 c6 -2 -15 -4 -45 -4 -30 0 -61 3 -68 8 -12 7 90 4 113 -4z m88
-12 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m350 0 c-13 -2 -33
-2 -45 0 -13 2 -3 4 22 4 25 0 35 -2 23 -4z"
          />
          <path
            d="M4620 3520 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"
          />
          <path
            d="M2341 2608 c-1 -14 -5 -28 -10 -30 -4 -1 -11 -20 -15 -40 l-7 -38 36
0 c19 0 35 1 35 3 -1 1 -9 31 -20 67 -12 41 -19 55 -19 38z"
          />
          <path
            d="M3818 2682 c-13 -2 -18 -13 -18 -38 0 -35 0 -35 43 -32 39 3 42 5 45
34 3 28 0 32 -25 36 -15 2 -36 2 -45 0z m42 -43 c0 -5 -9 -9 -20 -9 -11 0 -20
4 -20 8 0 4 9 8 20 9 11 1 20 -2 20 -8z"
          />
          <path
            d="M1076 2664 c-3 -9 -6 -67 -6 -130 l0 -114 28 0 c32 0 69 30 83 68 11
29 5 100 -12 143 -16 42 -81 64 -93 33z m74 -104 c-5 -22 -8 -27 -9 -13 -1 21
9 56 14 51 2 -2 0 -19 -5 -38z"
          />
          <path
            d="M1531 2583 c-7 -26 -14 -55 -17 -64 -3 -13 4 -16 35 -16 34 0 39 3
32 16 -5 9 -12 34 -15 56 -10 59 -22 62 -35 8z m16 -45 c-3 -8 -6 -5 -6 6 -1
11 2 17 5 13 3 -3 4 -12 1 -19z"
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  // Render as external link
  return (
    <a
      href={APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'block', width: '100%', height: '100%' }}
    >
      {logo}
    </a>
  );
}
